"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerStats = void 0;
var ts_money_1 = require("ts-money");
var Invoice_1 = __importDefault(require("./Invoice"));
var Vehicle_1 = __importDefault(require("./Vehicle"));
var Customer = /** @class */ (function () {
    function Customer(json) {
        this.id = json.id;
        this.name = json.name;
        this.phoneNumber = json.phoneNumber;
        this.emailAddress = json.emailAddress;
        this.vehicles = null;
        if (json.vehicles) {
            this.vehicles = json.vehicles.map(function (vehicleJSON) { return new Vehicle_1.default(vehicleJSON); });
        }
        this.invoices = null;
        if (json.invoices) {
            this.invoices = json.invoices.map(function (invoiceJSON) { return new Invoice_1.default(invoiceJSON); });
        }
        this.createdAt = new Date(json.createdAt);
        this.extraData = new CustomerData(json.extraData);
    }
    Object.defineProperty(Customer.prototype, Symbol.toStringTag, {
        get: function () {
            return 'Customer';
        },
        enumerable: false,
        configurable: true
    });
    return Customer;
}());
exports.default = Customer;
var CustomerData = /** @class */ (function () {
    function CustomerData(json) {
        this.address = json.address;
        this.gender = json.gender;
        this.dateOfBirth = json.dateOfBirth;
    }
    Object.defineProperty(CustomerData.prototype, Symbol.toStringTag, {
        get: function () {
            return 'CustomerData';
        },
        enumerable: false,
        configurable: true
    });
    return CustomerData;
}());
var CustomerStats = /** @class */ (function () {
    function CustomerStats(json) {
        this.customerID = json.customerID;
        this.numberOfInvoices = json.numberOfInvoices;
        this.lifetimeSpend = ts_money_1.Money.fromInteger(json.lifetimeSpend, ts_money_1.Currencies.MYR);
        this.averageBasketSize = ts_money_1.Money.fromInteger(json.averageBasketSize, ts_money_1.Currencies.MYR);
    }
    Object.defineProperty(CustomerStats.prototype, Symbol.toStringTag, {
        get: function () {
            return 'CustomerStats';
        },
        enumerable: false,
        configurable: true
    });
    return CustomerStats;
}());
exports.CustomerStats = CustomerStats;
